import { AbstractControl, ValidationErrors } from '@angular/forms';

export function noSymbolsValidator(control: AbstractControl): ValidationErrors | null {
  const nameRegExp = /^[a-zA-Z0-9'-]+(\s+[a-zA-Z0-9'-]+)*$/;
  if (!control.value) {
    return null;
  }
  const forbidden = !control.value.match(nameRegExp);
  return forbidden ? { noSymbols: true } : null;
}
